import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "15",
  fill: "none",
  viewBox: "0 0 20 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m11.222.867 1.142 12.95-9.861.87a1.02 1.02 0 0 1-.653-.155.66.66 0 0 1-.307-.486l-.35-3.956c.595-.053 1.148-.293 1.539-.667.39-.374.586-.853.544-1.33s-.319-.913-.769-1.214S1.47 6.44.876 6.493l-.35-3.957a.66.66 0 0 1 .219-.532c.156-.15.377-.246.615-.267zm1.793-.158 4.482-.396c.238-.02.473.035.653.155s.29.295.307.486l.35 3.956c-.595.053-1.148.293-1.539.667-.39.374-.586.853-.544 1.33s.318.913.768 1.214 1.037.439 1.632.387l.349 3.956a.66.66 0 0 1-.218.532c-.156.15-.377.246-.615.267l-4.483.395z"
    }, null, -1)
  ])))
}
export default { render: render }